export default __webpack_public_path__ + "static/media/loading-purple.5e188d1f.svg";